import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ResetPassword from './resetPassword';
import Activation from './activationNewPassword';
import LoginForm from './loginForm';
import { Container } from './styledLoginComp';

function LoginRoutes() {
  return (
    <Switch>
      <Route exact path="/">
        <Container>
          <LoginForm />
        </Container>
      </Route>

      <Route path="/resetPassword/">
        <ResetPassword />
      </Route>
      <Route path="/password/reset/confirm/">
        <Activation />
      </Route>

      <Route>
        <h1>Помилились?</h1>
      </Route>
    </Switch>
  );
}

export default LoginRoutes;
